import { Paragraph } from 'components/src/typography';
import * as React from 'react';

type Props = {
  searchValue: string | null;
  loading: boolean;
  noDataFound: boolean;
  startSearch: boolean;
};

const SearchInfoText = ({ searchValue, loading, noDataFound, startSearch }: Props) => {
  return (
    !loading &&
    (noDataFound ? (
      <Paragraph classes="!font-bold text-black-100">{`Engar leitarniðurstöður fyrir leit "${searchValue}"`}</Paragraph>
    ) : (
      <Paragraph variant="large" classes="!font-bold text-black-100">
        {startSearch ? 'Leitarniðurstöður' : 'Leitartillögur'}
      </Paragraph>
    ))
  );
};
export default SearchInfoText;
